// extracted by mini-css-extract-plugin
export var footer = "_lt-0";
export var inherit = "_lt-1";
export var input = "_lt-2";
export var modalContent = "_lt-3";
export var quillEditor = "_lt-4";
export var subtitle = "_lt-5";